export enum ExtraIntraOralExaminationChartFields {
  ExtraOralExamination = 'ExtraOralExamination',
  IntraOralExamination = 'IntraOralExamination',
  OralDrawing = 'OralDrawing',
}

export enum ExtraIntraOralExaminationChartFeedbackFields {
  EvaluationChartId = 'evaluationChartId',
  Score = 'score',
  FeedbackContent = 'feedbackContent',
  FeedbackImage = 'feedbackImage',
}

export enum ExtraOralExamination {
  FacialSkin = 'Facial skin',
  FacialSymmetry = 'Facial symmetry',
  FacialMuscle = 'Facial muscle (안면근육 : 협근 및 교근)',
  ParotidGrand = 'Parotid grand (이하선 및 이하림프절)',
  OccipitalMuscleLymphNodes = 'Occipital muscle & Lymph Nodes\n(후드근과 후두 림프절)',
  MentalisMuscleMylohyoidMuscle = 'Mentalis muscle & mylohyoid muscle\n(이근과 하악설골근)',
  SCMMuscle = 'SCM muscle (흉쇄유돌근)',
  AuricularLymphNodes = 'Auricular lymph Nodes (이개 림프절)',
  ThyriodGland = 'Thyriod gland (갑상선)',
  TMJ = 'TMJ (약관절)',
}

export enum IntraOralExamination {
  Lip = 'Lip (상순과 하순)',
  Gingiva = 'Gingiva (치은)',
  BuccalMucosa = 'Buccal mucosa (협점막)',
  PapillaOfParotid = 'Papilla of parotid (이하선 유두)',
  FloorOfMouth = 'Floor of mouth (구강저)',
  AlveolarMucosa = 'Alveolar mucosa (치조점막)',
  Tongue = 'Tongue (혀)',
  HardPalate = 'Hard palate (경구개)',
  SoftPalate = 'Soft palate (연구개)',
  Oropharynx = 'Oropharynx (구강인두)',
}

export const ExtraIntraOralExaminationChartFormDefaultValues = {
  [ExtraIntraOralExaminationChartFields.ExtraOralExamination]: [],
  [ExtraIntraOralExaminationChartFields.IntraOralExamination]: [],
  [ExtraIntraOralExaminationChartFields.OralDrawing]: '',
};
